import { QATypeLabel } from './../models/QATypeLabel.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  Division,
  FillerMaterial,
  JointType,
  Material,
  RTAcceptedRejected,
  RTPercentage,
  StampAllocation,
  Unit,
  WeldGroup,
  WeldProcess,
  WPS,
  Size,
  Schedule,
  MaterialForm,
  QAType,
  Role,
  UserRole,
  Permission,
  ContractCompany,
  WeldTypeIdentifier,
  DefectType
} from '../models';
import { ModeOfOperation } from '../models/ModeOfOperation';
import { Technique } from '../models/Technique';
import { TypeOfEquipment } from '../models/TypeOfEquipment';
import { GTAWCurrentTypeAndPolarity } from '../models/GTAWCurrentTypeAndPolarity';
import { TransferMode } from '../models/TransferMode';
import { BackingGas } from '../models/BackingGas';
import { GasType } from '../models/GasType';
import { Progression } from '../models/Progression';
import { ClassificationType } from '../models/ClassificationTypes';
import { SFASpecification } from '../models/SFASpecification';
import { Position } from '../models/Position';
import { ConsumableInsertOperationModeGTAWPAWLBW } from '../models/ConsumableInsertOperationModeGTAWPAWLBW';
import { FillerMetalNo } from '../models/FillerMetalNo.model';
import { FillerMetalProduct } from '../models/FillerMetalProduct';
import { OperationMode } from '../models/OperationMode';

@Injectable({
  providedIn: 'root'
})
export class DropdownApiService {
  //#region 'Angular Life Cycle'
  constructor(protected _http: HttpClient) {}
  //#endregion

  //#region 'Get'
  public GetContractCompanyByRefineryAsync(refineryid: number): Observable<ContractCompany[]> {
    return this._http.get<ContractCompany[]>(
      `${environment.apiEndpoint}/ContractCompany/GetContractCompanyByRefineryAsync`,
      {
        params: { refineryid }
      }
    );
  }

  public GetDivisionsByRefineryAsync(refineryid: number): Observable<Division[]> {
    return this._http.get<Division[]>(`${environment.apiEndpoint}/division/GetDivisionsByRefineryAsync`, {
      params: { refineryid }
    });
  }

  public GetWeldTypeIdentifierAsync(): Observable<WeldTypeIdentifier[]> {
    return this._http.get<WeldTypeIdentifier[]>(
      `${environment.apiEndpoint}/WeldTypeIdentifier/GetWeldTypeIdentifierAsync`
    );
  }

  public GetFillerMaterialsAsync(): Observable<FillerMaterial[]> {
    return this._http.get<FillerMaterial[]>(`${environment.apiEndpoint}/fillermaterial/GetFillerMaterialsAsync`);
  }

  public GetJointTypesAsync(): Observable<JointType[]> {
    return this._http.get<JointType[]>(`${environment.apiEndpoint}/jointtype/GetJointTypesAsync`);
  }

  public GetMaterialAsync(): Observable<Material[]> {
    return this._http.get<Material[]>(`${environment.apiEndpoint}/Material/GetMaterialAsync`);
  }

  public GetMaterialFormAsync(): Observable<MaterialForm[]> {
    return this._http.get<MaterialForm[]>(`${environment.apiEndpoint}/MaterialForm/GetMaterialFormAsync`);
  }

  public GetQATypeAsync(): Observable<QAType[]> {
    return this._http.get<QAType[]>(`${environment.apiEndpoint}/QAType/GetQATypeAsync`);
  }

  public GetQATypeLabelAsync(qaTypeID: number): Observable<QATypeLabel[]> {
    return this._http.get<QATypeLabel[]>(`${environment.apiEndpoint}/QATypeLabel/GetQATypeLabelAsync`, {
      params: { qaTypeID }
    });
  }

  public GetRolesAsync(): Observable<Role[]> {
    return this._http.get<Role[]>(`${environment.apiEndpoint}/Role/GetRolesAsync`);
  }

  public GetAvailableUserRolesByUserAsync(userId: string, refineryId: number): Observable<UserRole[]> {
    return this._http.get<UserRole[]>(`${environment.apiEndpoint}/WeldManagerUser/GetAvailableUserRolesByUserAsync`, {
      params: { userId, refineryId }
    });
  }

  public GetRTAcceptedRejectedsByRefineryAsync(refineryid: number): Observable<RTAcceptedRejected> {
    return this._http.get<RTAcceptedRejected>(
      `${environment.apiEndpoint}/rtacceptedrejected/GetRTAcceptedRejectedsByRefineryAsync`,
      {
        params: { refineryid }
      }
    );
  }

  public GetRTPercentageByRefineryAsync(refineryid: number): Observable<RTPercentage[]> {
    return this._http.get<RTPercentage[]>(`${environment.apiEndpoint}/RTPercentage/GetRTPercentageByRefineryAsync`, {
      params: { refineryid }
    });
  }

  public GetScheduleAsync(): Observable<Schedule[]> {
    return this._http.get<Schedule[]>(`${environment.apiEndpoint}/Schedule/GetScheduleAsync`);
  }

  public GetSizeAsync(): Observable<Size[]> {
    return this._http.get<Size[]>(`${environment.apiEndpoint}/Size/GetSizeAsync`);
  }

  public GetUnitsByRefineryAndDivisionAsync(refineryid: number, divisionid: number): Observable<Unit[]> {
    return this._http.get<Unit[]>(`${environment.apiEndpoint}/unit/GetUnitsByRefineryAsync`, {
      params: { refineryid, divisionid }
    });
  }

  public GetUnitsByRefineryAsync(refineryid: number): Observable<Unit[]> {
    return this._http.get<Unit[]>(`${environment.apiEndpoint}/unit/GetUnitsByRefineryAsync`, {
      params: { refineryid }
    });
  }

  public GetWeldersStampAllocationAsync(refineryid: number): Observable<StampAllocation> {
    return this._http.get<StampAllocation>(`${environment.apiEndpoint}/welder/GetWeldersStampAllocationAsync`, {
      params: { refineryid }
    });
  }

  public GetWelderStampsByRefineryAsync(refineryid: number): Observable<StampAllocation> {
    return this._http.get<StampAllocation>(`${environment.apiEndpoint}/welder/GetWelderStampsByRefineryAsync`, {
      params: { refineryid }
    });
  }

  public GetAllWelderStampsByRefineryAsync(refineryid: number, active: boolean): Observable<StampAllocation> {
    return this._http.get<StampAllocation>(`${environment.apiEndpoint}/welder/GetWelderStampsByRefineryAsync`, {
      params: { refineryid, active }
    });
  }

  //this.tableData = await this._srvWelders.GetWelderStampsByRefineryAsync(this.refineryId, this.activeData);

  public GetWeldGroupByRefineryAsync(refineryid: number): Observable<WeldGroup[]> {
    return this._http.get<WeldGroup[]>(`${environment.apiEndpoint}/weldgroup/GetWeldGroupByRefineryAsync`, {
      params: { refineryid }
    });
  }

  public GetWeldProcessesAsync(): Observable<WeldProcess[]> {
    return this._http.get<WeldProcess[]>(`${environment.apiEndpoint}/weldprocess/GetWeldProcessesAsync`);
  }

  public GetWPsByRefineryAsync(refineryid: number): Observable<WPS[]> {
    return this._http.get<WPS[]>(`${environment.apiEndpoint}/wps/GetWPsByRefineryAsync`, {
      params: { refineryid }
    });
  }

  public GetDefectTypeAsync(defectTypeId?: number): Observable<DefectType[]> {
    return this._http.get<DefectType[]>(`${environment.apiEndpoint}/DefectType/GetDefectTypeAsync`);
  }

  public GetPermissionsAsync(): Observable<Permission[]> {
    return this._http.get<Permission[]>(`${environment.apiEndpoint}/Permission/GetPermissionsAsync`);
  }

  //weld inspection api service
  public GetOperationModeAsync(): Observable<OperationMode[]> {
    return this._http.get<OperationMode[]>(`${environment.apiEndpoint}/OperationMode/GetOperationModeAsync`);
  }

  public GetModeOfOperationAsync(): Observable<ModeOfOperation[]> {
    return this._http.get<ModeOfOperation[]>(`${environment.apiEndpoint}/ModeOfOperation/GetModeOfOperationAsync`);
  }
  public GetTechniqueAsync(): Observable<Technique[]> {
    return this._http.get<Technique[]>(`${environment.apiEndpoint}/Technique/GetTechniqueAsync`);
  }
  public GetTypeOfEquipmentAsync(): Observable<TypeOfEquipment[]> {
    return this._http.get<TypeOfEquipment[]>(`${environment.apiEndpoint}/EquipmentType/GetEquipmentTypeAsync`);
  }
  public GetGTAWCurrentTypeAndPolarityAsync(): Observable<GTAWCurrentTypeAndPolarity[]> {
    return this._http.get<GTAWCurrentTypeAndPolarity[]>(
      `${environment.apiEndpoint}/GTAWCurrentPolarity/GetGTAWCurrentPolarityAsync`
    );
  }
  public GetTransferModeAsync(): Observable<TransferMode[]> {
    return this._http.get<TransferMode[]>(`${environment.apiEndpoint}/TransferMode/GetTransferModeAsync`);
  }
  public GetBackingGasAsync(): Observable<BackingGas[]> {
    return this._http.get<BackingGas[]>(`${environment.apiEndpoint}/BackingGas/GetBackingGasAsync`);
  }
  public GetGasTypeAsync(): Observable<GasType[]> {
    return this._http.get<GasType[]>(`${environment.apiEndpoint}/GasType/GetGasTypeAsync`);
  }
  public GetProgressionAsync(): Observable<Progression[]> {
    return this._http.get<Progression[]>(`${environment.apiEndpoint}/Progression/ProgressionsAsync`);
  }
  public GetFillerMetalFNoAsync(): Observable<FillerMetalNo[]> {
    return this._http.get<FillerMetalNo[]>(`${environment.apiEndpoint}/FillerMetalFNo/GetFillerMetalFNoAsync`);
  }

  public GetFillerMetalProductAsync(): Observable<FillerMetalProduct[]> {
    return this._http.get<FillerMetalProduct[]>(
      `${environment.apiEndpoint}/FillerMetalProduct/GetFillerMetalProductAsync`
    );
  }

  public GetSFASpecificationAsync(): Observable<SFASpecification[]> {
    console.log('API Endpoint:', environment.apiEndpoint);
    return this._http.get<SFASpecification[]>(`${environment.apiEndpoint}/SFASpecification/GetSFASpecificationAsync`);
  }
  public GetClassificationTypesAsync(): Observable<ClassificationType[]> {
    return this._http.get<ClassificationType[]>(
      `${environment.apiEndpoint}/ClassificationType/GetClassificationTypeAsync`
    );
  }
  GetConsumableInsertOperationModeGTAWPAWLBWAsync(): Observable<ConsumableInsertOperationModeGTAWPAWLBW[]> {
    return this._http.get<ConsumableInsertOperationModeGTAWPAWLBW[]>(
      `${environment.apiEndpoint}/ConsumableInsertOperationModeGTAWPAWLBW/GetGetConsumableInsertOperationModeGTAWPAWLBWAsync`
    );
  }
  GetPositionAsync(): Observable<Position[]> {
    return this._http.get<Position[]>(`${environment.apiEndpoint}/Position/GetPositionAsync`);
  }
  //#endregion
}
